<template>
  <div class="row mt-5">
    <div class="col-1"></div>
    <div class="col-10">
      <base-button v-b-toggle.collapse-noti block class="btn-primary"> Notificaciones</base-button>
      <b-collapse id="collapse-noti">
        <b-card title="Notificaciones" sub-title="Crear notificación">
          <div class="row">
            <div class="col-4">
              <ValidationObserver v-slot="{ invalid }">
                <form @submit.prevent="onSubmit">
                  <div class="col-12">
                    <label for="name">Mensaje</label>
                    <ValidationProvider name="notification.description" rules="required" v-slot="{ errors }">
                      <textarea id="name" class="form-control" v-model="notification.description" rows="3"
                                placeholder="Escribe aqui el mensaje ..."></textarea>
                      <p>{{ errors[0] }}</p>
                    </ValidationProvider>
                  </div>
                  <div class="col-12">
                    <label>Fecha inicial</label>
                    <base-input addon-left-icon="ni ni-calendar-grid-58">
                      <flat-picker slot-scope="{focus, blur}"
                                   @on-open="focus"
                                   @on-close="blur"
                                   :config="{allowInput: true}"
                                   class="form-control datepicker"
                                   v-model="notification.date_start">
                      </flat-picker>
                    </base-input>
                  </div>
                  <div class="col-12">
                    <label>Fecha final</label>
                    <base-input addon-left-icon="ni ni-calendar-grid-58">
                      <flat-picker slot-scope="{focus, blur}"
                                   @on-open="focus"
                                   @on-close="blur"
                                   :config="{allowInput: true}"
                                   class="form-control datepicker"
                                   v-model="notification.date_end">
                      </flat-picker>
                    </base-input>
                  </div>
                  <div class="col-12">
                    <base-button type="primary btn_submit" @click="onSubmit"
                                 :disabled="invalid">Guardar
                    </base-button>
                  </div>
                </form>
              </ValidationObserver>
            </div>
            <div class="col-8">
              <div class="table-responsive table-flush">
                <base-table class="table align-items-center"
                            thead-classes="table-light"
                            tbody-classes="list"
                            :data="notifications">
                  <template slot="columns">
                    <th>Mensaje</th>
                    <th>Fecha Inicial</th>
                    <th>Fecha Final</th>
                    <th></th>
                  </template>
                  <template slot-scope="{row}">
                    <th scope="row">
                      <div class="media align-items-center">
                        <div class="media-body">
                          <span class="name mb-0 text-sm">{{ row.description }}</span>
                        </div>
                      </div>
                    </th>
                    <td>{{ row.date_start }}</td>
                    <td>{{ row.date_end }}</td>
                    <td>

                        <div class="btn_icon_edit" @click="EditNotify(row)"></div>
                        <div class="btn_icon_delete" @click="Delete(row.notify_id)"></div>


                    </td>

                  </template>
                </base-table>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import {bus} from "@/components/Configuration/bus_configuration";
import {configuration_service} from "@/services/configuration/ConfigurationService";
import {extend, ValidationProvider} from 'vee-validate'
import {ValidationObserver} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'
import swal from "sweetalert";


extend('required', {
  ...required,
  message: 'Este campo es requerido'
})
export default {
  name: "Notification",
  components: {ValidationProvider, ValidationObserver},
  data() {
    return {
      notifications: [],
      notification: {
        description: '',
        date_start: '',
        date_end: ''
      }
    }
  },
  methods: {
    EditNotify(row) {
      this.notification.description = row.description
      this.notification.date_start = row.date_start
      this.notification.date_end = row.date_end
      this.notification.notify_id = row.notify_id
    },
    onSubmit() {
      console.log(this.notification)
      configuration_service.CreateNotify(this.notification)
    },
    cleandata() {
      this.notification = {
        description: '',
        date_start: '',
        date_end: ''
      }
    },
    formatedate(value) {
      var date = new Date(value);
      return date.toISOString().slice(0, 10);
    },
    Delete(notify_id){

      swal("¿Seguro que desea eliminar la notificación?", {
        buttons: {
          cancel: "Cancelar",
          Aceptar: true,
        },
      })
          .then((value) => {
            switch (value) {
              case "Aceptar":
                configuration_service.DeleteNotify(notify_id)
                break;
            }
          });
    }
  },
  created() {
    configuration_service.GetAllNotify()
    bus.$on('GetAllNotify', (response) => {
      this.notifications = response
    })
    bus.$on('CreateNotify', (response) => {
      configuration_service.GetAllNotify()
      this.cleandata()
      if (response) {
        swal({
          icon: "success",
          text: "Se Han Guardado los datos correctamente",
          button: "Aceptar"
        })
      }
    })
    bus.$on('DeleteNotify',(response)=>{
      configuration_service.GetAllNotify()
      if (response) {
        swal({
          icon: "success",
          text: "Se Han Guardado los datos correctamente",
          button: "Aceptar"
        })
      }
    })
  }
}
</script>

<style scoped>

</style>